<ng-container *ngIf="!rendering?.fields?.SelectedCategory">
  
  <section class="pb-pb-7 pb-relative pb-overflow-clip" >
    <div class="pb-c-hero pb-c-hero-article-text pb-overflow-x-clip pb-relative pb-flex pb-items-end before:!pb-content-none">
      <div class="pb-card-hero pb-card-hero-article pb-text-center pb-p-4 pb-pb-5 pb-flex pb-flex-col pb-items-center pb-gap-4 pb-w-full lg:pb-p-7 lg:pb-gap-5">
        <h1 class="pb-text-d-xl-m pb-text-color-brand pb-font-serif pb-line-clamp-3 lg:pb-text-d-xl pb-max-w-[52.5rem]">{{rendering?.fields?.result?.SelectedTag?.BlogTagTitle}}</h1>
        <div *ngIf="rendering?.fields?.result?.SelectedTag?.BlogTagSubtitle" class="pb-text-md pb-hidden md:pb-block pb-max-w-[52.5rem]">{{rendering?.fields?.result?.SelectedTag?.BlogTagSubtitle}}</div>
      </div>
    </div>
  </section>

  <app-breadcrumb *ngIf="breadcrumbData" [data]="breadcrumbData"></app-breadcrumb>
  
</ng-container>

<section class="pb-container">
  <div class="pb-m-filter pb-flex pb-flex-wrap pb-justify-center pb-gap-4 pb-gap-y-0">
    <ng-container *ngFor="let category of rendering?.fields?.result?.BlogCategories">
      <div class="swiper-slide !pb-w-fit pb-py-3 pb-cursor-pointer pb-whitespace-nowrap">
        <a hybridHref hreflang="{{language}}" href="{{category?.CategoryPage?.Href}}" class="pb-c-filter-item pb-whitespace-nowrap" ngClass="{{rendering?.fields?.SelectedCategory?.id===category['ID'] ? 'pb-filter--active' : ''}}">{{category?.CategoryPage?.Text}}</a>
      </div>
    </ng-container>
  </div>
</section>

<section class="pb-m-blog pb-mt-5 lg:pb-mt-13">
  <div class="pb-container pb-py-7">
    <div class="pb-grid pb-grid-cols-1 lg:pb-grid-cols-2 xl:pb-grid-cols-4 pb-m-blog-grid pb-gap-6">
      <ng-container *ngFor="let blog of blogs">
        <a hybridHref hreflang="{{language}}" href="{{blog?.Link?.Href}}" attr.aria-label="{{blog?.Link?.Text}}" class="pb-c-blog-card-container">
          <div class="pb-c-blog-card pb-card--scaleUP pb-h-full pb-w-full pb-border pb-flex pb-flex-col pb-cursor-pointer">
            <div class="pb-p-5 pb-pb-4 pb-blog-content">
              <div class="pb-flex pb-gap-x-3 pb-mb-3">
                  <span class="pb-text-xs">{{ blog?.BlogArticleReleaseDate | date:'dd/MM/yyyy' }}</span>
                  <span class="pb-text-xs pb-font-bold" *ngIf="blog?.BlogArticleReadingTime">| {{blog?.BlogArticleReadingTime}}</span>
              </div>
              <h3 class="pb-mb-4 pb-font-bold pb-text-h-xs pb-line-clamp-4" [innerHTML]="blog?.NavigationTitle | TrustHtml"></h3>
            </div>
            <div class="pb-relative pb-h-full pb-w-full pb-overflow-hidden">
              <img *ngIf="(!isMobile && blog.BlogArticleImage?.Href!='' && blog.BlogArticleImage) || blog.BlogArticleImageMobile?.Href=='' || !blog.BlogArticleImageMobile" class="pb-object-cover pb-h-full pb-w-full" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="blog.BlogArticleImage?.Href" [alt]="blog.BlogArticleImage?.Alt != '' ? blog.BlogArticleImage?.Alt : blog?.NavigationTitle+'_image'">
              <img *ngIf="(isMobile && blog.BlogArticleImageMobile?.Href!='' && blog.BlogArticleImageMobile) || blog.BlogArticleImage?.Href=='' || !blog.BlogArticleImage" class="pb-object-cover pb-h-full pb-w-full" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="blog.BlogArticleImageMobile?.Href" [alt]="blog.BlogArticleImageMobile?.Alt != '' ? blog.BlogArticleImageMobile?.Alt : blog?.NavigationTitle+'_mobileImage'">
              <a (click)="$event.stopPropagation();" *ngIf="blog?.BlogArticleCategory?.CategoryPage?.Text!=''" hybridHref hreflang="{{language}}" href="{{blog?.BlogArticleCategory?.CategoryPage?.Href}}" class="pb-tag pb-absolute pb-left-4 pb-bottom-4 !pb-border-none !pb-px-4 !pb-py-1 pb-cursor-pointer">{{blog?.BlogArticleCategory?.CategoryPage?.Text}}</a>
            </div>
          </div>
        </a>
      </ng-container>
    </div>
    <button type="button" class="pb-btn pb-btn-primary pb-mx-auto pb-mt-6" *ngIf="blogs.length < rendering?.fields?.result?.TotalResults" (click)="getBlog()">{{ 'show-more' | translate }}</button>
  </div>
</section>

